import { QUESTION_STARTER } from '../types';

export const createQuestionStarter = (parentNodeType, siblingNodeTypes = []) => ({
  type: QUESTION_STARTER,
  parentNodeType,
  siblingNodeTypes,
  children: [
    {
      text: '',
    },
  ],
});
